import React from "react";
import { Link } from "react-router-dom";
import SuperAdminLayout from "@/components/SuperAdminLayout";
import { Crown, ArrowRight, ShieldCheck } from "lucide-react";

/**
 * v1.2 PR-B.5 — Replaces the previous "Coming in PR-B" stub.
 *
 * The actual provision-super-admin elevation card is housed inside the
 * Integration Vault (`/super-admin/integrations`) because it shares the
 * same secrets-handling primitives. This page exists for the dedicated
 * sidebar tab and routes the operator one click further.
 */
export default function SuperAdminProvision() {
  return (
    <SuperAdminLayout>
      <div className="max-w-2xl" data-testid="super-admin-provision-page">
        <div className="inline-flex items-center gap-2 mb-2">
          <Crown className="w-5 h-5" style={{ color: "#FF8A4C" }} />
          <div className="eb-overline">Super admin</div>
        </div>
        <h1 className="text-3xl font-semibold text-navy-900 dark:text-white mb-2">
          Provision a new super admin
        </h1>
        <p className="text-sm text-navy-500 dark:text-navy-300 mb-6">
          Elevation requires the platform's <code className="px-1 rounded bg-navy-50 dark:bg-navy-700">SUPER_ADMIN_ELEVATION_TOKEN</code> and
          is irreversible without a database write. The tool lives in the Integration Vault page
          alongside the other privileged primitives so a single audit row covers the entire flow.
        </p>
        <div className="bg-white dark:bg-navy-800 border border-navy-100 dark:border-navy-700 rounded-xl p-6 space-y-4">
          <div className="inline-flex items-center gap-2">
            <ShieldCheck className="w-5 h-5 text-orange-500" />
            <h2 className="font-semibold text-navy-900 dark:text-white">Open the elevation card</h2>
          </div>
          <p className="text-sm text-navy-600 dark:text-navy-200">
            The <strong>Provision super admin</strong> card is at the bottom of the Integration
            Vault page. Every elevation writes a <code className="font-mono text-xs px-1 rounded bg-navy-50 dark:bg-navy-700">user.elevated_to_super_admin</code> audit row.
          </p>
          <Link
            to="/super-admin/integrations#provision-super-admin-card"
            className="inline-flex items-center gap-1.5 px-3 py-2 rounded-md text-sm font-medium bg-navy-900 dark:bg-navy-700 text-white hover:bg-navy-800 dark:hover:bg-navy-600"
            data-testid="provision-go-to-vault"
          >
            Open Integration Vault <ArrowRight className="w-3.5 h-3.5" />
          </Link>
        </div>
      </div>
    </SuperAdminLayout>
  );
}
